/* 画像プレビュー画面 */
import React from 'react';
import { Button, Modal, ModalBody } from 'react-bootstrap';

interface Props {
  show: boolean;
  image_source: string;
  image_width: number;
  image_height: number;
  handleOnclick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const PreviewModal: React.FC<Props> = ({
  show,
  image_source,
  image_width,
  image_height,
  handleOnclick,
}) => {
  return (
    <Modal
      id="preview-modal"
      size="lg"
      centered
      show={show}
      animation={false}
      onHide={handleOnclick}
    >
      <Modal.Header>
        <Button className="close-button" onClick={handleOnclick} />
      </Modal.Header>
      <ModalBody>
        <img src={image_source} />
      </ModalBody>
    </Modal>
  );
};

export default PreviewModal;
